module.exports = __webpack_public_path__ + "img/ep-maison.37062851.jpg";